import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { Flex, Text, Tooltip } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

export type TooltipBookingProductOverbookingProps = {
  withIcon?: boolean
}

export function TooltipBookingProductOverbooking({
  withIcon = true,
}: TooltipBookingProductOverbookingProps) {
  const { t: tShared } = useTranslation('shared', { keyPrefix: 'shared' })
  const { t } = useTranslation('saas', { keyPrefix: 'booking_items' })

  return (
    <Tooltip
      label={t('tooltip_overbooking')}
      withinPortal
      zIndex={9999}
      w={250}
      multiline
    >
      <Flex
        align='center'
        style={{ cursor: 'default', display: 'inline-flex' }}
      >
        <Text c='orange' size='sm'>
          {tShared('overbooking')}
        </Text>
        {withIcon && (
          <Text c='orange' ml='xs'>
            <Icon icon={faInfoCircle} size='xs' />
          </Text>
        )}
      </Flex>
    </Tooltip>
  )
}
